import { render, staticRenderFns } from "./kdxHintAlert.g.vue?vue&type=template&id=4a1b39fb&scoped=true"
import script from "./kdxHintAlert.g.vue?vue&type=script&lang=js"
export * from "./kdxHintAlert.g.vue?vue&type=script&lang=js"
import style0 from "./kdxHintAlert.g.vue?vue&type=style&index=0&id=4a1b39fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b39fb",
  null
  
)

export default component.exports